var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoSwift = function SvgLogoSwift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1a1a",
    d: "M96.55 119.144c-15.079 9.72-35.81 10.719-56.667.743C22.995 111.869 8.983 97.833 0 81.797c4.312 4.009 9.342 7.218 14.731 10.023 21.54 11.266 43.075 10.495 58.23.028a.176.176 0 0 1-.022-.028C51.38 73.375 33.056 49.317 19.403 29.67c-2.876-3.208-5.032-7.217-7.187-10.826 16.527 16.84 42.758 38.09 52.098 44.107-19.76-23.258-37.367-52.125-36.65-51.325C58.925 46.912 88.03 66.961 88.03 66.961c.963.606 1.706 1.11 2.304 1.561a57.164 57.164 0 0 0 1.647-5.57C97.011 42.503 91.264 19.245 78.687 0c29.102 19.647 46.35 56.535 39.162 87.41-.187.833-.39 1.655-.61 2.463.084.112.168.227.252.346 14.37 20.05 10.419 41.299 8.622 37.29-7.795-17.024-22.227-11.818-29.564-8.365z"
  })));
};

export default SvgLogoSwift;